export default __webpack_public_path__ + "static/media/FRAX.6ed06f08.svg";